import {
  AvatarData,
  AvatarDataIcon,
  AvatarDataImage,
  AvatarDataInitials,
  ColorUtils,
  DecoratedAvatarData,
  StatusBadgeData,
  TypeBadgeData,
  UserProfileData
} from "ui-ts";
import {
  CheckUtils,
  OrganizationDetailsProvider,
  UserCategoryVoData,
  UserStatusVoData,
  UserTypeVoData,
  UserVoData
} from "od-ts";
import {NameUtils} from "@utils/name-utils";

export class UserConverter {
  private static _organizationDetailsProvider: OrganizationDetailsProvider;

  static set organizationDetailsProvider(value: OrganizationDetailsProvider) {
    this._organizationDetailsProvider = value;
  }

  static convertToUserProfileData(user: UserVoData, organization: string, fileUrl?: string, target?: UserProfileData): UserProfileData {
    if (CheckUtils.isEmpty(user) || CheckUtils.isEmpty(user.profile)) return null;

    var result = (target == null) ? new UserProfileData() : target;

    result.firstName = user.profile.firstName;
    result.lastName = user.profile.lastName;
    result.email = user.profile.email;
    result.organization = organization;

    UserConverter.convertToDecoratedAvatarData(user, fileUrl, result.decoratedAvatarData);
    return result;
  }

  static convertToDecoratedAvatarData(user: UserVoData, fileUrl?: string, target?: DecoratedAvatarData): DecoratedAvatarData {
    if (CheckUtils.isEmpty(user)) return null;

    var result = (target == null) ? new DecoratedAvatarData() : target;
    result.id = user.id;
    result.firstname = user.profile.firstName;
    result.lastName = user.profile.lastName;
    result.email = user.profile.email;
    if (user.type==UserTypeVoData.BOT && this._organizationDetailsProvider !=null && this._organizationDetailsProvider.ready) {
      result.displayName = this._organizationDetailsProvider.model.appearanceOptions.botName;
    }else{
      result.displayName = user.profile.displayName;
    }


    result.type = this.convertToTypeBadgeData(user.category);
    result.status = this.convertToStatusBadgeData(user.status);
    result.avatarData = this.convertToAvatarData(user, fileUrl);
    result.hideType = true;

    return result;
  }

  static convertToTypeBadgeData(userCategory: UserCategoryVoData): TypeBadgeData {
    if (CheckUtils.isEmpty(userCategory)) return TypeBadgeData.ANONYMOUS;

    switch (userCategory) {
      case UserCategoryVoData.CUSTOMER:
        return TypeBadgeData.CUSTOMER;
      case UserCategoryVoData.USER:
        return TypeBadgeData.USER;
      case UserCategoryVoData.BOT:
        return TypeBadgeData.BOT;
      default:
        return TypeBadgeData.ANONYMOUS;
    }
  }

  static convertToStatusBadgeData(userCategory: UserStatusVoData): StatusBadgeData {
    if (CheckUtils.isEmpty(userCategory)) return StatusBadgeData.OFFLINE;

    switch (userCategory) {
      case UserStatusVoData.ONLINE:
        return StatusBadgeData.ONLINE;
      case UserStatusVoData.AWAY:
        return StatusBadgeData.AWAY;
      case UserStatusVoData.BUSY:
        return StatusBadgeData.BUSY;
      case UserStatusVoData.INVISIBLE:
        return StatusBadgeData.INVISIBLE;
      default:
        return StatusBadgeData.OFFLINE;
    }
  }

  static convertToAvatarData(user: UserVoData, fileUrl?: string): AvatarData {
    if (CheckUtils.isEmpty(user)) return null;

    if (user.profile.photoUrl != null || (user.profile.pictureKey != null && fileUrl != null)) {
      var imageResult: AvatarDataImage = new AvatarDataImage();
      if (user.profile.photoUrl != null) imageResult.url = user.profile.photoUrl;
      else imageResult.url = fileUrl + "view/" + user.profile.pictureKey;
      return imageResult;
    }
    switch (user.type) {
      case UserTypeVoData.USER_TYPE_1:
      case UserTypeVoData.USER_TYPE_2:
      case UserTypeVoData.USER_TYPE_3:
      case UserTypeVoData.USER_TYPE_4:
      case UserTypeVoData.USER_TYPE_5:
      case UserTypeVoData.USER_TYPE_6:
      case UserTypeVoData.USER_TYPE_7:
      case UserTypeVoData.USER_TYPE_8:
      case UserTypeVoData.USER_TYPE_9:
      case UserTypeVoData.USER_TYPE_10:
        return UserConverter.getAvatarData(user, "odi_user");
      case UserTypeVoData.CUSTOMER_TYPE_1:
      case UserTypeVoData.CUSTOMER_TYPE_2:
      case UserTypeVoData.CUSTOMER_TYPE_3:
      case UserTypeVoData.CUSTOMER_TYPE_4:
      case UserTypeVoData.CUSTOMER_TYPE_5:
      case UserTypeVoData.CUSTOMER_TYPE_6:
      case UserTypeVoData.CUSTOMER_TYPE_7:
      case UserTypeVoData.CUSTOMER_TYPE_8:
      case UserTypeVoData.CUSTOMER_TYPE_9:
      case UserTypeVoData.CUSTOMER_TYPE_10:
        return UserConverter.getAvatarData(user, "odi_customer");
      case UserTypeVoData.BOT:
        if (this._organizationDetailsProvider !=null && this._organizationDetailsProvider.ready) {
          if(!CheckUtils.isEmpty(this._organizationDetailsProvider.model.appearanceOptions.botImageUrl)){
            imageResult = new AvatarDataImage();
            imageResult.url = this._organizationDetailsProvider.model.appearanceOptions.botImageUrl;
            return imageResult;
          }
        }
        return UserConverter.getAvatarDataIcon("odi_bot");
      case UserTypeVoData.ANONYMOUS:
      default:
        return UserConverter.getAvatarDataIcon("odi_user");
    }
  }

  static getAvatarData(user: UserVoData, iconName: string): AvatarDataInitials | AvatarDataIcon {
    if (!CheckUtils.isEmpty(user.profile) && (!CheckUtils.isEmpty(user.profile.firstName) ||
      !CheckUtils.isEmpty(user.profile.lastName) || !CheckUtils.isEmpty(user.profile.displayName))) {
      var initialsResult: AvatarDataInitials = new AvatarDataInitials();
      initialsResult.initials = (user.profile.displayName) ? NameUtils.getInitials(user.profile.displayName)
        : NameUtils.getInitials(user.profile.firstName) + NameUtils.getInitials(user.profile.lastName);
      initialsResult.color = ColorUtils.getDecToHex(user.profile.color);
      initialsResult.fontColor = "#FFFFFF";
      return initialsResult;
    } else {
      return UserConverter.getAvatarDataIcon(iconName);
    }
  }

  static getAvatarDataIcon(iconName: string, iconColor = "#FFFFFF", borderColor = "#666666"): AvatarDataIcon {
    let iconResult: AvatarDataIcon = new AvatarDataIcon();
    iconResult.icon = iconName;
    iconResult.iconColor = iconColor;
    iconResult.borderColor = borderColor;
    return iconResult;
  }
}



// WEBPACK FOOTER //
// ./src/utils/converter/user-converter.ts